export default __webpack_public_path__ + "media/builders/background-circle-fill-2-8c5cb86a.png";